// Garde-fou commun à toute écriture d'une famille ou d'un ordre du catalogue
// (écrans Classique « Familles » et « Ordres », tunnel de création V2,
// propositions de l'agent) : le rapprochement avec l'UICN et entre propositions
// se fait par le nom latin, il doit donc être propre et unique.
//
// - espaces en trop retirés (un nom latin commençant par une tabulation ne
//   correspondait plus à rien) ;
// - noms français, anglais et latin exigés ;
// - jamais deux entrées actives du même nom latin (casse indifférente) : la
//   création rend l'entrée existante, la modification est refusée.

const FIELDS = Object.freeze({
  family: Object.freeze({ id: "familyId", name: "familyName", englishName: "familyEnglishName", latinName: "familyLatinName" }),
  order: Object.freeze({ id: "orderId", name: "orderName", englishName: "orderEnglishName", latinName: "orderLatinName" }),
});

const text = (value) => (typeof value === "string" ? value.replace(/\s+/g, " ").trim() : "");
const sameLatin = (a, b) => Boolean(text(a)) && text(a).toUpperCase() === text(b).toUpperCase();

/**
 * @param {"family"|"order"} kind
 * @param {object} entry     champs à écrire (création, ou seulement les champs modifiés)
 * @param {Array} existing   entrées actuelles de la collection
 * @param {object} [current] entrée modifiée telle qu'elle est en base (modification)
 * @returns {{ ok: true, entry } | { ok: false, code: "MISSING_NAMES", missing: string[] } | { ok: false, code: "DUPLICATE", duplicate: object }}
 *          `entry` : les seuls champs à écrire, nettoyés.
 */
export function checkTaxonEntry(kind, entry = {}, existing = [], current = null) {
  const fields = FIELDS[kind];
  if (!fields) throw new Error(`[TAXON_GUARD_UNKNOWN_KIND] ${kind}`);
  const cleaned = { ...entry };
  [fields.name, fields.englishName, fields.latinName].forEach((key) => {
    if (key in cleaned) cleaned[key] = text(cleaned[key]);
  });
  // Majuscule initiale du nom latin (« MUSTELIDAE » → « Mustelidae »), comme le tunnel.
  if (cleaned[fields.latinName]) {
    const latin = cleaned[fields.latinName].toLowerCase();
    cleaned[fields.latinName] = latin.charAt(0).toUpperCase() + latin.slice(1);
  }
  // Une modification ne porte que ses champs : on contrôle l'entrée qui en résulte.
  const result = { ...(current || {}), ...cleaned };
  const missing = [fields.name, fields.englishName, fields.latinName].filter((key) => !text(result[key]));
  if (missing.length) return { ok: false, code: "MISSING_NAMES", missing };
  const selfId = result[fields.id] || null;
  const duplicate = (Array.isArray(existing) ? existing : []).find((item) =>
    !item?.mergedInto && (item?.[fields.id] || item?.id) !== selfId && sameLatin(item?.[fields.latinName], result[fields.latinName]));
  if (duplicate) return { ok: false, code: "DUPLICATE", duplicate };
  return { ok: true, entry: cleaned };
}
